<div
  class="chatbot-history-item d-flex align-items-center gap-2 rounded-3 p-2 border bg-white text-dark"
  :class="{ active: is_active }"
  @click="$emit('select', conversation.id)"
>
  <div class="chatbot-history-item-body min-w-0 flex-grow-1">
    <p class="text-dark text-xs fw-semibold mb-1 text-truncate">
      {{ conversation_title }}
    </p>
    <p class="text-secondary text-xs mb-0 text-truncate">
      {{ conversation_preview }}
    </p>
    <time
      v-if="conversation_timestamp"
      class="chatbot-history-timestamp d-flex align-items-center flex-wrap mt-2 fw-semibold gap-1 text-xxs lh-sm"
      :datetime="conversation_timestamp_value"
      :title="conversation_timestamp"
    >
      <span class="chatbot-history-date d-inline-flex align-items-center mw-100 rounded-pill overflow-hidden text-nowrap py-1 px-2 text-secondary bg-body-tertiary border">{{ conversation_date_label }}</span>
    </time>
  </div>

  <button
    v-if="can_delete"
    class="btn btn-sm btn-link text-secondary border-0 d-inline-flex align-items-center justify-content-center p-0 chatbot-delete-btn"
    @click.stop="$emit('delete', conversation.id)"
    aria-label="Delete conversation"
    title="Delete conversation"
  >
    <i class="bi bi-trash3"></i>
  </button>
</div>
